export { default } from './SendAlternate'
